<template>
    <div :class="['forum-header', { 'is-static': isStatic || isFixed }]">
        <img
                class="bk-logo"
                src="../images/common/logo.png"
                width="188px"
                height="32px"
                alt="蓝鲸logo"
                @click="goToDoc({ url: '', target: true })"/>
        <p class="logo-title">学习社区</p>
        <ul class="nav-list">
            <li
                    :class="['nav-item', { 'is-active': curNavTab === navItem.name }]"
                    v-for="(navItem, navIdx) in navList"
                    :key="navIdx"
                    @click="goToDoc(navItem)">
                {{ navItem.title }}
            </li>
        </ul>
        <!-- <search-select class="header-search" placeholder="请输入关键字"></search-select> -->
        <div class="ask-btn primary" @click="onCreateAsk()">提问</div>
        <div class="ask-btn default" @click="onCreateAsk(true)">写文章</div>
        <span v-if="!isLogin" @click="login()" class="login-btn">登录</span>
        <span v-if="!isLogin" @click="login()" class="login-btn register">注册</span>
        <template v-else>
            <el-popover
                    placement="bottom"
                    trigger="click"
                    popper-class="msg-popover"
                    v-model="visible">
                <span class="msg-icon" slot="reference">
                    <i :class="['message-solid', {'active': visible}]"></i>
                    <i class="red-circle" v-if="isHaveUnread"></i>
                </span>
                <div class="popover-content" v-loading="loading">
                    <p class="msg-title">
                        <span class="title">
                            消息通知
                            <span class="num">({{ msgLength }})</span>
                        </span>
                        <span class="view-more" @click="onViewMore">查看更多</span>
                    </p>
                    <el-tabs class="msg-content" v-model="activeMsg" @tab-click="handleTabClick">
                        <el-tab-pane
                                class="tab-item"
                                v-for="tabItem in msgTabList"
                                :key="tabItem.name"
                                :name="tabItem.name">
                        <span slot="label">
                        <el-badge :hidden="!tabsTotal[tabItem.name]" :value="tabsTotal[tabItem.name]" :max="99">
                            {{ tabItem.label }}
                        </el-badge>
                        </span>
                        </el-tab-pane>
                    </el-tabs>
                    <ul class="val-list" v-loading="loading ? false : tabLoading" element-loading-text="拼命加载中">
                        <template v-if="componentData.length">
                            <li
                                    class="val-item"
                                    v-for="(infoItem, infoIndex) in componentData"
                                    :key="infoIndex">
                                <span class="val-circle"></span>
                                <p class="val-content" v-html="filterXSS(infoItem.notify)"></p>
                                <span class="val-time">{{ infoItem.updated }}</span>
                            </li>
                        </template>
                        <li v-else class="data-null">
                            <img src="../images/personal_center/data-null.png" alt="">
                            <p>没有数据</p>
                        </li>
                    </ul>
                </div>
            </el-popover>
            <el-popover placement="bottom" trigger="hover" width="227" :popper-class="'user-info-pop'">
                <div slot="reference" class="user-info">
                    <span class="name">{{ userInfo.nick_name || userInfo.username }}</span>
                    <el-tooltip v-if="userInfo.is_official" effect="light" content="蓝鲸智云官方" placement="right">
                        <svg style="width: 20px; height: 20px" aria-hidden="true">
                            <use xlink:href="#icon-lanjingguanfang"></use>
                        </svg>
                    </el-tooltip>
                    <el-tooltip v-if="userInfo.is_vip" effect="light" content="核心用户" placement="right">
                        <span class="icon-vipuser"></span>
                    </el-tooltip>
                    <span class="triangle"></span>
                </div>
                <p class="whale" @click="skip('/s-mart/personal_center/')">
                    <img src="../images/community/coins.png"
                         v-if="!userInfo.avatar || userInfo.avatar.substr(0, 1) === '?'">
                    <img v-else :src="userInfo.avatar" alt=""/>
                    <span class="text">鲸币</span>
                    <span class="count">{{ userInfo.bkb | formatNumber }}</span>
                </p>
                <p class="menu-item" @click="skip('/s-mart/personal_center/')">个人中心</p>
                <p class="menu-item" @click="skip('/s-mart/personal_center/store')">鲸币商城</p>
                <p class="menu-item" @click="skip('/s-mart/vip')">{{ userInfo.is_vip ? '查看我的核心权益' : '申请成为核心用户' }}</p>
                <a class="menu-item" href="javascript:smart.logout(logout_callback);">退出登录</a>
            </el-popover>
        </template>
        <secondary :show="secondaryState" :hasEmail="emailState" :hasPhone="phoneState"></secondary>
    </div>
</template>

<script>
import searchSelect from './common/searchSelect.vue';
import information from './information.vue'
import secondary from "./secondary.vue"
import Cookies from 'js-cookie'
import bus from '@/js/bus.js'

export default {
    components: {
        searchSelect,
        secondary
    },
    filters: {
        formatNumber(num) {
            num += '';
            let x = num.split('.');
            let x1 = x[0];
            let x2 = x.length > 1 ? '.' + x[1] : '';
            let rgx = /(\d+)(\d{3})/;
            while (rgx.test(x1)) {
                x1 = x1.replace(rgx, '$1' + ',' + '$2');
            }
            return x1 + x2;
        }
    },
    data() {
        return {
            isStatic: false,
            isFixed: false,
            curNavTab: 'forum',
            navList: [
                {
                    title: '首页',
                    name: 'forum',
                    url: '/s-mart/communities'
                }, {
                    title: '问答',
                    name: 'qa',
                    url: '/s-mart/community/question'
                }, {
                    title: '文章',
                    name: 'article',
                    url: '/s-mart/community/article'
                }, {
                    title: '文档中心',
                    name: 'docs',
                    url: '/docs',
                    target: true
                }
            ],
            isLogin: false,
            tabsTotal: {
                follow: 0,
                remind: 0,
                latter: 0,
                system: 0
            },
            tabsData: {
                follow: [],
                remind: [],
                latter: [],
                system: []
            },
            msgTabList: [
                {
                    label: '回复与获赞',
                    name: 'follow'
                }, {
                    label: '关注更新',
                    name: 'remind'
                }, {
                    label: '系统消息',
                    name: 'system'
                }
            ],
            loading: false,
            followLoading: false,
            remindLoading: false,
            latterLoading: false,
            systemLoading: false,
            isHaveUnread: false,
            componentData: [],
            activeMsg: 'follow',
            prevActive: '',
            visible: false,
            userInfo: {}
        }
    },
    computed: {
        tabLoading() {
            return this[`${this.activeMsg}Loading`]
        },
        msgLength() {
            let result = 0
            Object.values(this.tabsTotal).forEach(item => {
                result += item
            })
            if (!result) {
                this.isHaveUnread = false
            }
            return result
        },
        secondaryState() {
            return this.$store.state.secondaryShow
        },
        emailState() {
            return this.$store.state.hasEmail
        },
        phoneState() {
            return this.$store.state.hasPhone
        }
    },
    watch: {
        visible(val) {
            if (val) {
                this.componentData = []
                this.getAllTabMsgList()
            }
        },
        '$route'(val) {
            this.setCurNavTab(val)
        }
    },
    created() {
        this.setCurNavTab()
        this.init()
        window.addEventListener('scroll', this.handleScroll)
    },
    beforeDestroy() {
        window.removeEventListener('scroll', this.handleScroll)
    },
    methods: {
        handleScroll() {
            this.isStatic = window.scrollY > 0
        },
        // 前往其他页面
        goToDoc(navInfo) {
            if (navInfo.url === window.location.pathname) {
                window.location.reload()
                return
            }
            const {url, isCloud, target} = navInfo
            if (target) {
                const link = isCloud ? url : (window.location.origin + url)
                window.open(link, '_blank')
            } else {
                this.$router.push({
                    path: navInfo.url
                })
            }
        },
        // 设置当前选中导航
        setCurNavTab(val) {
            const {pathname} = window.location
            this.navList.some(item => {
                if (pathname.indexOf(item.url) > -1) {
                    if (['qa', 'article'].includes(item.name) && val) {
                        const type = val.query.type
                        const curRouteName = item.name
                        if (type) {
                            this.curNavTab = type === 'answer' ? 'qa' : 'article'
                        } else {
                            this.curNavTab = curRouteName
                        }
                    } else {
                        this.curNavTab = item.name
                    }
                    return true
                }
            })
            // 固定导航
            this.isFixed = pathname.indexOf('communities') === -1
        },
        // 提问&写文章
        onCreateAsk(isArticle) {
            if (!this.isLogin) {
                axios.get(myUrl + 'login/test/')
                return
            }
            // 校验信息是否完善
            if (!this.$store.state.informationComplete) {
                bus.$emit('openInformationPopup')
                return
            }
            let query = {}
            query.type = isArticle ? 'article' : undefined
            let routeData = this.$router.resolve({
                path: '/s-mart/community/ask',
                query
            })
            window.open(routeData.href, '_blank')
        },
        // 登录
        login() {
            try {
                axios.post(myUrl + "login/get_user_info/").then((res) => {
                    res = res.data
                    this.userInfo = res.data
                    this.isLogin = true
                    localStorage.setItem('isFirstLogin', true)
                    this.$store.commit('setLoginStatus', true)
                    this.$store.commit('setUserInfo', res.data)
                })
            } catch (error) {
                console.warn(error)
            }
        },
        // 查看更多
        onViewMore() {
            let routeData = this.$router.resolve({
                path: `/s-mart/personal_center/message_center/?tabName=${this.activeMsg}`
            });
            window.open(routeData.href, '_blank')
            this.visible = false
        },
        // 查询是否有未读数据
        getHaveUnread() {
            try {
                axios.get(myUrl + `api/notify/record/have_unread/`).then(res => {
                    if (!res.data.result) return
                    this.isHaveUnread = res.data.data.have_unread
                })
            } catch (error) {
                console.warn(error)
            }
        },
        pollingHaveUnread() {
            Promise.resolve(this.getHaveUnread()).then(res => {
                setTimeout(() => {
                    this.pollingHaveUnread()
                }, 300000);
            })
        },
        // 获取所有tab的消息列表
        async getAllTabMsgList() {
            this.loading = true
            const promiseArray = this.msgTabList.map(item => this.getTabContent(item.name))
            Promise.all(promiseArray).then(res => {
                this.loading = false
                // activeMsg 默认为tab栏第一个有未读消息的
                for (const [key, value] of Object.entries(this.tabsTotal)) {
                    if (value !== 0) {
                        this.activeMsg = key
                        this.componentData = this.tabsData[key].map(item => {
                            item.updated = this.getTime(item.create_time)
                            return item
                        })
                        this.onReadNotify(key)
                        return
                    }
                }
            })
        },
        // 获取tab栏内容数据
        async getTabContent(type = this.activeMsg) {
            try {
                this[`${type}Loading`] = true
                await axios.get(myUrl + `api/notify/record/list_unread/?type=${type}`).then(res => {
                    if (!res.data.result) return
                    const {total, data} = res.data.data
                    this.tabsTotal[type] = total
                    this.tabsData[type] = data
                    if (type === this.activeMsg) {
                        this.componentData = data
                        this.componentData.forEach(item => {
                            item.updated = this.getTime(item.create_time)
                        })
                    }
                    this[`${type}Loading`] = false
                })
            } catch (error) {
                console.warn(error)
                this[`${type}Loading`] = false
            }
        },
        // 切换tab
        handleTabClick(data) {
            this.getTabContent()
            this.onReadNotify(data.name)
        },
        // 单个tab已读
        onReadNotify(type) {
            if (!this.prevActive) {
                this.prevActive = type
                return
            }
            axios.put(myUrl + `api/notify/record/read/?type=${this.prevActive}`).then(res => {
                if (!res.data.result) return
                this.tabsTotal[this.prevActive] = 0
                this.prevActive = type
            })
        },
        // 跳转
        skip(link) {
            try {
                axios.post(myUrl + "login/check/register/").then((res) => {
                    res = res.data
                    if (res.result) {
                        this.$router.push({
                            path: link
                        })
                    }
                })
            } catch (error) {
                console.warn(error)
            }
        },
        getTime(stringTime) {
            let minute = 1000 * 60;
            let hour = minute * 60;
            let day = hour * 24;
            let week = day * 7;
            let month = day * 30;
            let time1 = new Date().getTime(); // 当前的时间戳
            let time2 = Date.parse(new Date(stringTime)); // 指定时间的时间戳
            let time = time1 - time2;
            let result = null;
            const date = stringTime.split(' ')[0]
            if (time / month >= 1 || time / week >= 1) {
                result = date
            } else if (time / day >= 1) {
                result = parseInt(time / day) + '天前';
            } else if (time / hour >= 1) {
                result = parseInt(time / hour) + '小时前';
            } else if (time / minute >= 1) {
                result = parseInt(time / minute) + '分钟前';
            } else {
                result = '刚刚'
            }
            return result;
        },
        init() {
            let isFirstLogin = localStorage.getItem('isFirstLogin')
            if (isFirstLogin === null) {
                localStorage.setItem('isFirstLogin', true)
            }
            if (!Cookies.get('p_skey')) return
            try {
                axios.post(myUrl + "login/check/").then((res) => {
                    if (!res.data.status) {
                        return
                    }
                    // 获取用户登录信息
                    this.getUserInfo()
                })
                this.username = window.username
            } catch (error) {
                console.warn(error)
            }
        },
        getUserInfo() {
            try {
                axios.post(myUrl + "login/get_user_info/").then((res) => {
                    const resp = res.data
                    // 用户已登录
                    this.isLogin = true
                    this.userInfo = resp.data
                    if (resp.data.user_id) {
                        this.$store.commit('setUserInfo', resp.data)
                        this.$store.commit('setLoginStatus', true)
                        // 如果用户登录则轮询查是否有未读数据
                        this.pollingHaveUnread()
                    }
                    const isFirstLogin = localStorage.getItem('isFirstLogin')
                    if (isFirstLogin === 'true') {
                        localStorage.setItem('isFirstLogin', false)
                        const {information_popup, wx_popup} = resp.data
                        if (information_popup) { // 弹出信息完善弹框
                            this.$parent.isInformationPopup = true
                        } else if (wx_popup) { // 弹出关注社区二维码
                            this.$parent.isWxPopup = true
                        }
                    }
                })
            } catch (error) {
                console.warn(error)
            }
        }
    }
}
</script>

<style lang="scss">
@import '@/scss/scrollbar.scss';

.msg-popover {
    z-index: 1000001 !important;
    width: 360px;
    height: 396px;
    padding: 0;

    .popover-content {
        padding: 14px 0 !important;

        .el-loading-mask {
            top: 1px;
        }
    }

    .msg-title {
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 14px;
        padding: 0 16px 0;
        margin-bottom: 8px;

        .title {
            font-weight: 700;
            color: #63656e;
            line-height: 19px;

            .num {
                color: #63656e;
                width: 36px;
                font-weight: 400;
                text-align: center;
            }
        }

        .view-more {
            cursor: pointer;
            color: #3a84ff;
            font-size: 12px;
        }
    }

    .msg-content {
        font-size: 12px;

        .el-tabs__header {
            padding: 0 16px;
            margin-bottom: 0;

            .el-tabs__nav-wrap::after {
                height: 1px;
                background: #dcdee5;
            }

            .el-tabs__nav {
                height: 36px;
                width: 100%;

                .el-tabs__active-bar {
                    width: 60px !important;
                    height: 2px !important;
                    background: #3a84ff;
                }

                .el-tabs__item {
                    padding: 0 18px;
                    height: 36px;
                    width: 60px;
                    text-align: center;
                    box-sizing: content-box;
                    line-height: 36px;
                    text-align: center;
                    font-size: 12px !important;
                    color: #63656e;

                    .el-badge__content {
                        top: 8px !important;
                        right: 10px;
                        color: #ffffff;
                        padding: 0 5px;
                        background: #ea3636;
                        font-family: HelveticaNeue;
                    }

                    &.is-active,
                    &:hover {
                        color: #3a84ff;
                    }

                    &:nth-child(2) {
                        padding-left: 0 !important;
                    }
                }
            }
        }
    }

    .val-list {
        color: #63656e;
        line-height: 20px;
        height: 300px;
        overflow-y: auto;
        @include scrollbar;
        padding: 7px 16px 20px;
        font-size: 12px;

        .val-item {
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-bottom: 10px;

            .val-circle {
                align-self: start;
                display: inline-block;
                flex-shrink: 0;
                width: 4px;
                height: 4px;
                background: #979ba5;
                border-radius: 50%;
                margin: 8px 12px 0 0;
            }

            .val-content {
                flex: 1;
                text-align: left;
                color: #63656e;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                /* autoprefixer: off */
                -webkit-box-orient: vertical;
                /* autoprefixer: on */
                em {
                    font-style: normal;
                }

                a:hover {
                    text-decoration: underline;
                }
            }

            .val-time {
                color: #c4c6cc;
                flex-shrink: 0;
                align-self: start;
                min-width: 60px;
                text-align: right;
                margin-left: 10px;
            }

            &:hover {
                .val-circle {
                    background: #3a84ff;
                }
            }
        }
    }

    .data-null {
        padding: 80px 0 20px;
        width: 100%;
        text-align: center;
        color: #63656e;

        img {
            width: 150px;
            height: 80px;
            margin-bottom: 10px;
        }
    }
}
</style>
<style lang="scss" scoped>
@font-face {
    font-family: 'TencentSansW3';
    src: url('../fonts/TencentSansW3.otf');
}

.forum-header {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 10003;
    width: 100%;
    min-width: 1200px;
    height: 60px;
    display: flex;
    align-items: center;
    padding: 0 30px 0 24px;
    background: rgba($color: #0a0a1a, $alpha: 0.1);

    .bk-logo {
        cursor: pointer;
    }

    .logo-title {
        display: flex;
        align-items: center;
        position: relative;
        top: -1px;
        font-size: 16px;
        color: #fff;
        opacity: 0.7;
        margin-left: 16px;
        font-family: TencentSansW3, TencentSansW3-Regular;

        &::before {
            content: '';
            position: absolute;
            top: 3px;
            left: -8px;
            width: 1px;
            height: 20px;
            background: #fff;
            opacity: 0.7;
        }
    }

    .nav-list {
        flex: 1;
        flex-shrink: 0;
        display: flex;
        align-items: center;
        margin-left: 84px;

        .nav-item {
            height: 60px;
            flex-shrink: 0;
            display: flex;
            align-items: center;
            color: #fff;
            opacity: 0.7;
            position: relative;
            margin-right: 30px;
            cursor: pointer;

            &.is-active, &:hover {
                opacity: 1;

                &::after {
                    content: '';
                    position: absolute;
                    left: 0;
                    bottom: 0;
                    height: 2px;
                    width: 100%;
                    background: #fff;
                    border-radius: 1px;
                }
            }

            &:last-child {
                margin-right: 0;
            }
        }
    }

    .header-search {
        width: 172px;
        max-width: 338px;
        margin-left: 25px;
        background: rgba($color: #fff, $alpha: 0.08);
        border: none;

        .el-input__inner {
            height: 32px;
            font-size: 12px;
            border-radius: 2px;
        }

        .el-input__caret {
            line-height: 32px;
        }

        &.is-focus {
            border: 1px solid #3a84ff;
            background: rgba(255, 255, 255, 0.08);
        }
    }

    .msg-icon {
        margin-left: 32px;
        position: relative;

        .message-solid {
            height: 16px;
            width: 16px;
            display: inline-block;
            cursor: pointer;
            position: relative;
            top: 2px;
            right: 0px;
            background-image: url('../images/community/notice-fill.png');
            background-size: 100% 100%;

            &.active,
            &:hover {
                background-image: url('../images/community/lamp-nine-hover.png');
                background-size: 100% 100%;
            }
        }

        .red-circle {
            position: absolute;
            top: 1px;
            right: -1px;
            width: 8px;
            height: 8px;
            background: #ea3536;
            border: 1px solid #0a0a1a;
            border-radius: 50%;
        }
    }

    .ask-btn {
        width: 60px;
        height: 26px;
        text-align: center;
        line-height: 26px;
        font-size: 12px;
        border-radius: 2px;
        cursor: pointer;

        &:hover {
            border-color: #979ba5;
        }

        &.primary {
            color: #fff;
            border-color: #3a84ff;
            background: #3a84ff;
            margin: 0 8px 0 24px;

            &:hover {
                background: #1768ef;
                border-color: #1768ef;
            }
        }

        &.default {
            border: 1px solid rgba(255, 255, 255, 0.30);
            color: rgba(255, 255, 255, 0.76);

            &:hover {
                border: 1px solid rgba(255, 255, 255, 1);
                color: rgba(255, 255, 255, 1);
            }
        }
    }

    .login-btn {
        margin-left: 24px;
        color: #fff;
        opacity: 0.76;
        cursor: pointer;

        &.register {
            position: relative;
            margin-left: 18px;

            &::before {
                content: '';
                position: absolute;
                left: -12px;
                top: 10px;
                height: 2px;
                width: 2px;
                border-radius: 50%;
                background: #fff;
            }
        }

        &:hover {
            opacity: 1;
        }
    }

    .user-info {
        display: flex;
        align-items: center;
        margin-left: 22px;
        color: #fff;
        cursor: pointer;
        opacity: 0.76;

        .name {
            margin-right: 2px;
        }

        .triangle {
            display: inline-block;
            position: relative;
            top: 3px;
            margin-left: 5px;
            border: 6px solid;
            border-color: #fff transparent transparent transparent;
        }

        &:hover {
            opacity: 1;
        }
    }

    &:hover, &.is-static {
        background: rgba($color: #0a0a1a, $alpha: 0.86);
    }
}
</style>



// WEBPACK FOOTER //
// forumHeader.vue?357b7e51